import React from "react";
import classes from "./Divider.module.scss";

export const Divider: React.FC = () => {
  return <span className={classes.line} />;
};
